import {
  GroupResourceAdapterInteface,
  ListGroupResourcesInput,
} from 'src/adapter/GroupResourceAdapterInterface';
import { GroupResourceModelAttributes } from 'src/models/GroupResourceModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosGroupResourceAdapter implements GroupResourceAdapterInteface {
  async listGroupResources(
    conditions?: ListGroupResourcesInput
  ): Promise<{ total: number; data: GroupResourceModelAttributes[] }> {
    try {
      const res = await api.get('/group-resources', {
        params: conditions,
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
